const ALLOWED = true;
const NOT_ALLOWED = false;

const RULES_KEYS = {
  petFriendly: 'pets',
  smokingAllowed: 'smoking',
  couplesAllowed: 'couples',
  gender: 'gender',
  onlyStudents: 'students',
  onlyPostgraduateStudents: 'postgraduates',
  onlyWorkers: 'workers'
};

const GENDER_STRING_CORRELATION = {
  onlyMales: 'only-male',
  onlyFemales: 'only-female'
};

const GENDER_ICON_RULE = {
  onlyMales: 'onlyMales',
  onlyFemales: 'onlyFemales'
};

const PROPERTY_RULES_ICONS = {
  petFriendly: {
    [ALLOWED]: 'pets_allowed',
    [NOT_ALLOWED]: 'pets_not_allowed'
  },
  smokingAllowed: {
    [ALLOWED]: 'smoking_allowed',
    [NOT_ALLOWED]: 'smoking_not_allowed'
  },
  couplesAllowed: {
    [ALLOWED]: 'couples_allowed',
    [NOT_ALLOWED]: 'person'
  },
  gender: {
    [GENDER_ICON_RULE.onlyFemales]: 'female',
    [GENDER_ICON_RULE.onlyMales]: 'male'
  },
  onlyStudents: 'perfect_for_students',
  onlyPostgraduateStudents: 'perfect_for_students',
  onlyWorkers: 'perfect_for_professionals'
};

const PROPERTY_TENANT_TYPE = {
  STUDENTS: 'students',
  WORKERS: 'workers',
  ANY: 'any'
};

const isRuleNameValid = (rule, landlordRules) =>
  Object.keys(RULES_KEYS).includes(rule) && landlordRules[rule] !== 'any';

const getLocoKeys = (name, value) => {
  const hasGenderRule = name === 'gender';

  if (value === true && !hasGenderRule) {
    return `${RULES_KEYS[name]}.allowed`;
  } else if (hasGenderRule) {
    return `${RULES_KEYS[name]}.${GENDER_STRING_CORRELATION[value]}`;
  }
  return `${RULES_KEYS[name]}.not-allowed`;
};

// NOTE: Until property rules model consider students and poststudens as other rules, we need to exclude them from "rule allowed" logic.
function isRuleAllowed(ruleName, ruleValue) {
  return (
    ruleValue &&
    ruleName !== 'onlyStudents' &&
    ruleName !== 'onlyPostgraduateStudents' &&
    ruleName !== 'onlyWorkers'
  );
}
const propertyFor = landlordRules => {
  if (!landlordRules) {
    return PROPERTY_TENANT_TYPE.ANY;
  }

  const { onlyStudents, onlyPostgraduateStudent, onlyWorkers } = landlordRules;
  if (
    (onlyStudents && onlyStudents.value) ||
    (onlyPostgraduateStudent && onlyPostgraduateStudent.value)
  ) {
    return PROPERTY_TENANT_TYPE.STUDENTS;
  }
  if (onlyWorkers && onlyWorkers.value) {
    return PROPERTY_TENANT_TYPE.WORKERS;
  }
  return PROPERTY_TENANT_TYPE.ANY;
};

const rulesMap = {
  petsAllowed: {
    key: 'petFriendly',
    texts: {
      yes: '',
      no: '',
      yesWithRestrictions: 'property.rule.pets.allowed.withRestrictions'
    }
  },
  smokingAllowed: {
    key: 'smokingAllowed',
    texts: {
      yes: '',
      no: '',
      yesBedroom: 'property.rule.smoking.allowed.yesBedroom',
      yesBalconyTerrace: 'property.rule.smoking.allowed.yesBalconyTerrace',
      yesKitchen: 'property.rule.smoking.allowed.yesKitchen',
      yesOpenWindows: 'property.rule.smoking.allowed.yesOpenWindows',
      yesGarden: 'property.rule.smoking.allowed.yesGarden'
    }
  }
};

export const getRulesFromFeatures = features => {
  if (!features) {
    return {};
  }
  return Object.keys(features).reduce((memo, current) => {
    const { value } = features[current];
    const ruleInfo = rulesMap[current];

    return ruleInfo
      ? {
          ...memo,
          [ruleInfo.key]: ruleInfo.texts[value]
        }
      : memo;
  }, {});
};

export {
  isRuleNameValid,
  isRuleAllowed,
  getLocoKeys,
  PROPERTY_RULES_ICONS,
  PROPERTY_TENANT_TYPE,
  propertyFor
};
